import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import fileReducer from "./slices/fileSlice";
import smartMergeReducer from "./slices/smartMergeSlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";

const rootReducer = combineReducers({
  auth: authReducer,
  file: fileReducer,
});

// Persist configs
const authPersistConfig = {
  key: "auth",
  storage: storageSession,
  whitelist: ["isLoggedIn", "user", "userID", "email", "googleEmail", "accessToken", "googleAccessToken", "linkedin_access_token", "refreshToken", "tokenExpiry", "maxUploadFileSize", "subscription", "planUploadLimit"],
};

const filePersistConfig = {
  key: "file",
  storage,
  whitelist: [
    "files",
    "uploadedFilePath",
    "localFileMeta",
    "lastResponse",
    "activeStep",
    "totalSteps",
    "processResponse",
    "applyResponse",
    "generativeEngineInsightsResult",
  ],
};

const smartMergePersistConfig = {
  key: "smartMerge",
  storage,
  whitelist: [
    "fileUrl1",
    "fileUrl2",
    "file1Columns",
    "file2Columns",
    "commonColumns",
    "selectedColumns1",
    "selectedColumns2",
    "joinKeys",
    "joinType",
    "mergedFileUrl",
    "blobFilePath",
    "activeTab",
    "appendMapping",
  ],
};


const persistedReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  file: persistReducer(filePersistConfig, fileReducer),
  smartMerge: persistReducer(smartMergePersistConfig,smartMergeReducer),
});

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/PURGE",
          "persist/REGISTER",
          "smartMerge/setFile1",
          "smartMerge/setFile2",
          "smartMerge/uploadAnalyze/pending",
        ],
        ignoredPaths: ["smartMerge.file1", "smartMerge.file2"],
      },
      immutableCheck: {
        ignoredPaths: ["smartMerge.file1", "smartMerge.file2"],
      },
    }),
});

export const persistor = persistStore(store);

export default store;